import React from 'react';
import styled from '@emotion/styled';
import _get from 'lodash.get';
import _isEqual from 'lodash.isequal';
import { connect } from 'react-redux';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import { newPlanpageMetaData, redirectToNewPlanpage, sendDataToGAWithGRX } from 'components/ToiSubscription/utils/redirectionToPlanPage';
import { getEncTicket, setPayloadInfo } from 'utils/primeUtil';
import { IMAGE_URL } from 'constants/index';
import Cookie from 'utils/cookies';
import { getGa4PageViewSet, collectEventfireGa4 } from 'utils/common';
import { BannerWidgetContainer, BulletList, BannerWidgetInner, BannerButton, BannerButtonWrapper } from './BannerWidget.style';

interface IBannerWidgetProps {
  data?: any,
  unifiedNodes?: any;
  type?: any,
  cardStyle?: any;
  index?: any,
  idx?: number;
  storyTitle?: string;
  msid?: string;
  fireGA?: any;
  isWapView?: boolean;
  hideCTA?: boolean;
  totalLength?: number;
  userData?: any;
  userPrcData?: any;
}

const BannerBulletStyle = {
  bulletListStyle: {
    marginBottom: '40px',
    marginTop: '16px',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#595959',
    background: `url("${IMAGE_URL}96222988.cms") no-repeat left top`,
    paddingLeft: '44px',
    DesktopfontSize: '18px',
    DesktoplineHeight: '24px',
  }
}

const BannerBulletStyleMobile = {
  bulletListStyle: {
    marginBottom: '20px',
    marginTop: '16px',
    fontSize: '16px',
    lineHeight: '25px',
    color: '#595959',
    background: `url("${IMAGE_URL}96222988.cms") no-repeat left top`,
    paddingLeft: '44px',
  }
}

const BannerButtonStyle = {
  bannerButtonStyle: {
    display: 'inline-block',
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '700',
    padding: '15px 32px',
    color: '#e21b22',
    background: 'transparent',
    border: '1px solid #e21b22',
    borderRadius: '8px',
    IpadfontSize: '20px',
    marginTop: '20px',
  }
}

const BannerButtonStyleMobile = {
  bannerButtonStyle: {
    display: 'inline-block',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '700',
    padding: '8px 24px',
    color: '#e21b22',
    background: 'transparent',
    border: '1px solid #e21b22',
    borderRadius: '8px',
    textAlign: 'center',
  }
}
interface BannerTextAlignProps {
  variant?: string,
}
const BannerTextAlign = styled.div<BannerTextAlignProps>`
  text-align: ${(props: BannerTextAlignProps) => props.variant ? props.variant : 'left'};
`;

const BannerWidget = ({
  cardStyle,
  index,
  data,
  storyTitle,
  msid,
  fireGA,
  isWapView,
  hideCTA,
  unifiedNodes,
  totalLength,
  userData,
  userPrcData,
}: IBannerWidgetProps) => {


  const fireGA4 = (obj?: any) => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      'event': 'select_item',
    }
    return collectEventfireGa4(collatedGadata,
      {
        item_name: window.location.href.indexOf('.cms') > -1 ? document.title : window.location.href,
        item_id: msid ? msid : '',
        item_brand: 'product_interventions',
        item_category: 'Nudges',
        item_category2: 'articleshow',
        item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
        item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
        location_id: obj?.location_id ? obj?.location_id : 'N/A',
      });
  }

  const redirection = (data: {} | undefined) => {
    if (Cookie.get('ssoid') || Cookie.get('ssoId')) {
      getEncTicket(isWapView).then(data => {
        window.location.href = redirectToNewPlanpage(
          newPlanpageMetaData({ ...data, unifiedNodes: unifiedNodes['prc0'], acqSubSource: `paywall_blocker_other_benefits_cta_${msid}` }, data),
        );
      });
    } else {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData({ ...data, unifiedNodes: unifiedNodes['prc0'], acqSubSource: `paywall_blocker_other_benefits_cta_${msid}` }),
      );
    }
  };

  const clickHandler = (e: any, index: number, data: any) => {
    e.preventDefault();
    setPayloadInfo(
      `Click_whytoiplus_subs CTA ${index}`,
      'STORY',
      storyTitle,
      msid,
    );
    fireGA(`Click_whytoiplus_subs CTA ${index}`);
    if (unifiedNodes['prc0']?.type === "newPlanpage") {
      const grxParams = [
        'paywall', {
          client_source: 'cdp',
          event_nature: 'click',
          event_category: 'subscription',
          cta_text: data?.h1 ? data?.h1 + ' ' + 'Subscribe Now' : '',
          // event_section: 'storypage_paywall_blocker',
          // event_sub_section: '',
          // landing_l1: 'plan_page',
          // landing_l2: '',
          // landing_l3: '',
          // landing_page_template: 'plan_page',
          // landing_url: redirectToNewPlanpage(
          //   newPlanpageMetaData({ ...data, unifiedNodes: unifiedNodes['prc0'] }),
          // ),
          // position: 3,
          unique_subscription_id: Cookie.get('_grx') + '_' + (new Date()).getTime(),
        }
      ];
      let cdpInfo = {};
      if (typeof (window as any).grx !== 'undefined' && typeof (window as any)?.grx_module?.hitPaywallEventReact === 'function') {
        (window as any).grx_module.hitPaywallEventReact(...grxParams);
        cdpInfo = (window as any).grx_module.getCdpInfo() || {};
      } else {
        (window as any).Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
          eventName: grxParams[0],
          payload: grxParams[1],
        });
      }
      const cdpParamsObj = grxParams[1] || {};

      const dataToBepassed = {
        accessiblefeatures: userPrcData?.accessibleFeatures,
        msid: msid,
        source: userPrcData?.source,
        accessType: userPrcData?.accessType,
        analytics_cdp: {
          eventName: grxParams[0],
          ...cdpParamsObj,
          ...cdpInfo
        },
        objUserData: {
          email: typeof userData?.getEmail !== 'undefined' ? userData.getEmail() : '',
          fname: typeof userData?.getFirstName !== 'undefined' ? userData.getFirstName() : ''
        },
        ga4Items: fireGA4({
          item_category4: e.target.innerText || '',
          item_category3: 'paywall_blocker_other_benefits_cta',
          location_id: `${index}_${data?.h1}`
        })
      }
      sendDataToGAWithGRX(dataToBepassed)
        .then(() => redirection({ ...data, unifiedNodes: unifiedNodes['prc0'] }))
    } else {
      window.location.href = data.ctaLink;
    }
  };

  // const getbulletList = () => {
  //   return (
  //     <BulletList styles={isWapView ? BannerBulletStyleMobile : BannerBulletStyle}>
  //       {data?.bullets?.map((val: any) => (
  //         <li
  //           dangerouslySetInnerHTML={{
  //             __html: val,
  //           }} />
  //       ))}
  //     </BulletList>
  //   )
  // }

  // const getCardContent = (cardThemeClass: string, cardContentClass: string) => {
  //   return (
  //     <div className={`flexbox ${cardContentClass !== undefined ? `${cardContentClass}Wrapper` : ''} ${data?.cardsRows === 'multiple' ? 'flexWrap' : ''}`}>
  //       {data?.cardMetaData?.map((data: any, index: number) => (
  //         <div key={index} className={`card ${cardContentClass !== undefined ? cardContentClass : ''} ${cardThemeClass !== undefined ? cardThemeClass : ''}`}>
  //           <div className="image">
  //             {data?.cardImgmsid &&
  //               <img src={`${IMAGE_URL}${data?.cardImgmsid}.cms`} alt={`banner ${index + 1}`} />
  //             }
  //             {data?.background &&
  //               <img src={`${IMAGE_URL}${data?.background}.cms`} alt={`banner ${index + 1}`} />
  //             }
  //             {data?.userImg &&
  //               <figure className={`avatar ${data?.position?.userIcon !== '' ? data?.position?.userIcon : ''}`}>
  //                 <img src={`${IMAGE_URL}${data?.userImg}.cms`} alt={`banner ${index + 1}`} />
  //               </figure>
  //             }
  //           </div>
  //           { data?.textContent &&
  //             <p className="testimonialText">{data?.textContent}</p>
  //           }
  //           {data?.h1 &&
  //             <div className="details">
  //               <h6 className="name">{data?.h1}</h6>
  //               <p>{data?.h2}</p>
  //             </div>
  //           }
  //         </div>
  //       ))
  //       }
  //     </div>
  //   )
  // }

  const getBannerWidgetText = () => {
    return (
      <div className={`${data?.sn === 10 || data?.layout !== 'single-column' ? 'flexbox' : '' || isWapView && 'flexbox'}`}>
        <span className="benefitsCounter">{index}</span>
      </div>
    )
  };

  const getBannerBtn = () => {
    return (
      !(hideCTA) && <BannerButton styles={isWapView ? BannerButtonStyleMobile : BannerButtonStyle} href={data?.ctaLink} onClick={(e: any) => {
        clickHandler(e, index, data);
      }}>{data?.ctaText}</BannerButton>
    )
  };

  return (
    <BannerWidgetContainer style={cardStyle} key={index}  >
      <BannerWidgetInner data={data}>
        {
          isWapView ? (
            <div className="contentwrapper">
              <div className='mblbenefitsWrapper'>
                {getBannerWidgetText()}
                <div className='mblbenefitsbannnerContent'>
                  <h2 className="benefitsHeading"
                    dangerouslySetInnerHTML={{
                      __html: data?.h1,
                    }}>
                  </h2>
                  <p className="benefitsdescription"
                    dangerouslySetInnerHTML={{
                      __html: data?.h2,
                    }}>
                  </p>
                </div>
              </div>
              {/* {data?.bullets &&
                getbulletList()
              } */}
              {data?.imgmsid && <div className="cardImage">
                <img src={`${IMAGE_URL}${data?.imgmsid}.cms`} alt={`banner ${index}`} />
              </div>}
              {/* {data?.p && <p className="text">{data?.p}</p>} */}
              {/* {data?.cardMetaData &&
                getCardContent(data?.cardThemeClass, data?.cardContentClass)
              } */}
              {/* {data?.moreText &&
                <strong className="moreText">
                  {data?.moreText}
                </strong>
              } */}
              {data?.ctaText &&
                <InViewObserver
                  key={index}
                  inViewCallback={() => {
                    fireGA(`View_whytoiplus_subs CTA ${index}`);
                  }}
                  viewMargin="0px 0px 80px 0px"
                >
                  <BannerButtonWrapper styles={BannerButtonStyleMobile}>
                    {getBannerBtn()}
                  </BannerButtonWrapper>
                </InViewObserver>
              }
            </div>
          ) : (
            <div className={`contentwrapper ${data?.cardContentClass ? data.cardContentClass : ''}`}>
              {data?.layout === 'single-column' ? (
                <BannerTextAlign variant='center'>
                  {/* {getBannerWidgetText()} */}
                  {data?.imgmsid && <img src={`${IMAGE_URL}${data?.imgmsid}.cms`} alt={`banner ${index}`} />}
                  {/* {getCardContent(data?.cardThemeClass, data?.cardContentClass)} */}
                  {/* {data?.moreText &&
                      <strong className="moreText">
                        {data?.moreText}
                      </strong>
                    } */}
                  {data?.ctaText &&
                    <InViewObserver
                      key={index}
                      inViewCallback={() => {
                        fireGA(`View_whytoiplus_subs CTA ${index}`);
                      }}
                      viewMargin="0px 0px 80px 0px"
                    >
                      {getBannerBtn()}
                    </InViewObserver>
                  }
                </BannerTextAlign>
              ) : (
                <div className={`flexbox align-center`}>
                  <div className={`widgetImage ${data?.positions?.img === 'right' ? 'order-2' : ''} ${data?.positions?.bgimg === 'no' ? 'no-bg' : ''}`}>
                    {data?.imgmsid &&
                      <img src={`${IMAGE_URL}${data?.imgmsid}.cms`} alt={`banner ${index}`} />}
                  </div>
                  <div className="widgetContent flexbox">
                    <div>
                      <span className="benefitsCounter">{index}</span>
                    </div>
                    <div>
                      <h2 className="benefitsHeading"
                        dangerouslySetInnerHTML={{
                          __html: data?.h1,
                        }}>
                      </h2>
                      <p className="benefitsdescription"
                        dangerouslySetInnerHTML={{
                          __html: data?.h2,
                        }}>
                      </p>
                      {data?.p && <p className="text">{data?.p}</p>}
                      {data?.ctaText &&
                        <InViewObserver
                          key={index}
                          inViewCallback={() => {
                            fireGA(`View_whytoiplus_subs CTA ${index}`);
                          }}
                          viewMargin="0px 0px 80px 0px"
                        >
                          {getBannerBtn()}
                        </InViewObserver>
                      }
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        }
      </BannerWidgetInner>
    </BannerWidgetContainer>
  );
};

const cachedResultIfPresent = (function getCachedResultIfAvailable() {
  let cachedData = { geo: {}, userData: {} };
  return (data: any) => {
    if (!_isEqual(cachedData, data)) {
      cachedData = data;
    }

    return cachedData;
  };
})();

const mapStateToProps = (state: any) => ({
  userData: cachedResultIfPresent({
    userData: _get(state, 'login.userData', {}),
    geo: _get(state, 'geo', null),
  })?.userData,
  userPrcData: state.login.userPrcData,
});

export default connect(mapStateToProps)(BannerWidget);